import React from "react";
import { Maximize2 } from "lucide-react";
import MermaidDiagram from "./MermaidDiagram";

export default function LineageTransformationViewer({
  loading,
  selectedMermaid,
  mermaidTypes = [],
  onSelectMermaid,
  loadingImage,
  loadingMessage = "Loading lineage transformation...",
  emptyMessage = "No resources found!",
  emptyTextClassName = "text-gray-700 text-[20px]",
  rootClassName = "h-full flex flex-col min-h-0",
  assetName = "",
}) {
  const getFullScreenUrl = () => {
    if (!assetName) return "";

    const params = new URLSearchParams();
    params.set("assetName", assetName);

    if (selectedMermaid?.name) {
      params.set("mermaid", selectedMermaid.name);
    }

    params.set("viewMode", "mermaid");

    return `/lineage-transformation?${params.toString()}`;
  };

  return (
    <div
      className={`${rootClassName} overflow-hidden`}
      style={{
        display: "grid",
        gridTemplateRows: "auto minmax(0, 1fr)",
      }}
    >
      <div className="flex items-center justify-start gap-2 shrink-0 border-b border-slate-200 px-2 py-2 overflow-x-auto">
        {mermaidTypes?.length > 0 && (
          <select
            name="mermaidName"
            value={selectedMermaid?.name || ""}
            onChange={(e) => onSelectMermaid?.(e.target.value)}
            className="px-3 py-1 text-xs rounded border bg-white text-gray-700 border-gray-300"
          >
            {mermaidTypes.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}

        {selectedMermaid?.is_llm_generated && (
          <div className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-gradient-to-r from-emerald-50 to-teal-50 text-emerald-700 px-3 py-1 text-xs font-semibold uppercase tracking-wide shadow-sm">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
            LLM Generated
          </div>
        )}
        {assetName && (
          <a
            href={getFullScreenUrl()}
            target="_self"
            title="View in full screen"
            aria-label="View in full screen"
            className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold whitespace-nowrap border border-blue-200 bg-blue-50 text-blue-700 shadow-sm transition-colors hover:border-blue-300 hover:bg-blue-100`}
          >
            <Maximize2 className="h-4 w-4" />
            <span>Full screen</span>
          </a>
        )}
      </div>

      <div className="min-h-0 h-full overflow-hidden">
        {loading ? (
          <div className="h-full min-h-0 flex flex-col items-center justify-center space-y-3">
            {loadingImage ? (
              <img src={loadingImage} alt="Loading..." className="h-30" />
            ) : null}
            <span className="text-gray-700 text-[20px] mt-[15px] text-center">
              {loadingMessage}
            </span>
          </div>
        ) : selectedMermaid ? (
          <div className="h-full min-h-0">
            <MermaidDiagram
              mermaidText={selectedMermaid?.mermaid_diagram || ""}
              summaries={selectedMermaid?.summaries || []}
              modalKey={selectedMermaid?.name}
            />
          </div>
        ) : (
          <div className="h-full min-h-0 flex flex-col items-center justify-center space-y-3">
            <span className={emptyTextClassName}>{emptyMessage}</span>
          </div>
        )}
      </div>
    </div>
  );
}
